import { render } from "./update.svg?vue&type=template&id=7912a7e0?inline"
const script = {}
script.render = render

export default script